export default __webpack_public_path__ + "static/media/bitcoin.46e8c106.jpg";